import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from 'react-spreadsheet-grid';
import { fetchReportFSNotesRequest } from '../redux/actions';
import { Typography } from '@mui/material';
import GridTitle from './GridTitle';
import GridTypography from './GridTypography';
import Loader from './Loader';

function ReportFSNotes(props) {
    const { engagementCode, branchSubCode } = props;
    const dispatch = useDispatch();

    const [columns, setColumns] = useState([])
    const [rows, setRows] = useState([]);

    const { loading, data: reportGroupDataSet, error } = useSelector((state) => state.reportFSNotes);

    useEffect(() => {
        if (engagementCode && branchSubCode) {
            dispatch(fetchReportFSNotesRequest(engagementCode, branchSubCode));
        }
    }, [branchSubCode, dispatch, engagementCode]);

    useEffect(() => {
        if (reportGroupDataSet) {
            setRows(reportGroupDataSet);
        }
    }, [reportGroupDataSet]);

    const initColumns = () => {
        return [
            {
                title: () => {
                    return (
                        <GridTitle title="#" tooltip="#" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.fsNoteCodes} tooltip={row.fsNoteCodes} />
                    );
                },
                id: 'fsNoteCodes',
            }, {
                title: () => {
                    return (
                        <GridTitle title="FS Notes" tooltip="FS Notes" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.fsNote} tooltip={row.fsNote} />
                    );
                },
                id: 'fsNote',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Target FS lines" tooltip="Target FS lines" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.fsLine} tooltip={row.fsLine} />
                    );
                },
                id: 'fsLine',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Interim" tooltip="Interim" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.interim} tooltip={row.interim} />
                    );
                },
                id: 'interim',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Preliminary" tooltip="Preliminary" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.preliminary} tooltip={row.preliminary} />
                    );
                },
                id: 'preliminary',
            }, {
                title: () => {
                    return (
                        <GridTitle title="CJE" tooltip="CJE" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.cjetotal} tooltip={row.cjetotal} />
                    );
                },
                id: 'cjetotal',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Adjusted" tooltip="Adjusted" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.adjusted} tooltip={row.adjusted} />
                    );
                },
                id: 'adjusted',
            }, {
                title: () => {
                    return (
                        <GridTitle title="GJE" tooltip="GJE" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.gjetotal} tooltip={row.gjetotal} />
                    );
                },
                id: 'gjetotal',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Final" tooltip="Final" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.final} tooltip={row.final} />
                    );
                },
                id: 'final',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Previous Year" tooltip="Previous Year" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.pfy} tooltip={row.pfy} />
                    );
                },
                id: 'pfy',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Comparative 2" tooltip="Comparative 2" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.comp2} tooltip={row.comp2} />
                    );
                },
                id: 'comp2',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Comparative 3" tooltip="Comparative 3" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.comp3} tooltip={row.comp3} />
                    );
                },
                id: 'comp3',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Comparative 4" tooltip="Comparative 4" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.comp4} tooltip={row.comp4} />
                    );
                },
                id: 'comp4',
            }
        ]
    };

    useEffect(() => {
        if (rows && rows.length > 0) {
            setColumns(initColumns());
        }
    }, [rows])

    return (
        <>
            {loading && <Loader />}
            {error && <Typography color="error">Error: {error}</Typography>}
            {columns && columns.length > 0 &&
                <Grid
                    columns={columns}
                    rows={rows}
                    getRowKey={row => row.tbId}
                    focusOnSingleClick={true}
                    isScrollable
                />
            }
        </>
    )
}

export default ReportFSNotes;